module.exports = __webpack_public_path__ + "media/assets/images/logos/nosco_modules_overview-fdbf8a65af0403df94e42d852d1b0d29.jpg";